import { isNotDefined } from '@sgme/fp';
import { ColTypeDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { useMemo } from 'react';
import { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import { RowData, SecondaryBatchColumnDefinition } from 'state/workspaces/secondary-market/batch/model';

const formatAmountOrPercent = (value: number, { context }: SecondaryBatchColumnDefinition, data?: RowData) => {
  const priceType = context.priceTypeId && data ? (data[context.priceTypeId] as SecondaryPriceType) : undefined;
  if (isNotDefined(value)) {
    return '';
  }
  if (priceType === 'Percent') {
    return `${value} %`;
  }
  const currency = context.currencyId && data ? (data[context.currencyId] as string) : undefined;
  return `${value} ${currency}`.trim();
};

export function usePercentOrAmountColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(() => {
    const formatValue = (value: number, data: RowData | undefined, colDef: SecondaryBatchColumnDefinition) =>
      formatAmountOrPercent(value, colDef, data);

    return {
      cellClass: 'ag-right-aligned-cell',
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      useValueFormatterForExport: true,
      filterValueGetter: ({ getValue, colDef, data }: ValueGetterParams<RowData>) => {
        const value = colDef.field ? getValue(colDef.field) : undefined;
        return formatValue(value, data, colDef as SecondaryBatchColumnDefinition);
      },
      valueFormatter: ({ value, data, colDef }: ValueFormatterParams<RowData>) => {
        const label = formatValue(value, data, colDef as SecondaryBatchColumnDefinition);
        return label;
      },
    };
  }, []);
}
